import React from "react";
import { Link } from "react-router-dom";
import PublicHeader from "./PublicHeader";
import PublicFooter from "./PublicFooter";
import IntegrationsBar from "./IntegrationsBar";
import SolutionChecklist, { SolutionChecklistItem } from "./SolutionChecklist";
import athleteImage from "../images/families/polaris-athlete-for-families.webp";
import revPrepBanner from "../images/landing-page/revolution-prep-banner.png";
import "../styles/solutions-page.css";
import "../styles/landing-page.css";

const FAMILY_INTRO =
    "Polaris Athlete Hub is available directly to families, no partner school or athletic program required. Our family subscriptions give student-athletes and parents access to the tools, resources, and guidance they need to navigate college admissions, athletic recruiting, NIL, and career readiness with clarity and confidence.";

const FAMILY_CARD_INTRO =
    "Polaris Athlete Hub gives families a centralized platform to support their student-athlete's journey. From college planning and athletic recruiting to NIL education and real-world skill development, everything families need to guide and support their athlete lives in one place.";

const FAMILY_FEATURES: SolutionChecklistItem[] = [
    {
        title: "College Counseling Tools",
        description:
            "Families can support their student-athlete with college planning tools, including a college list builder, school database with key admissions data, guided resources, and the ability to star schools and add notes.",
    },
    {
        title: "Next-Generation Communication Tools",
        description:
            "Pre-built outreach templates help student-athletes communicate with college coaches, admissions offices, and counselors.",
    },
    {
        title: "NIL Education",
        description:
            "Asynchronous NIL courses led by industry expert Bill Carter (25+ years in sports industry) prepare student-athletes for NIL opportunities with best practices and industry insights.",
    },
    {
        title: "Gameplan Tracking And Task Management",
        description:
            "Create personalized gameplans and track tasks to stay organized and on track with key milestones like NCAA eligibility.",
    },
    {
        title: "Exclusive Resources And Guides",
        description:
            "Access curated guides covering college admissions, recruiting, and NIL education.",
    },
    {
        title: "Curated Events And Programming",
        description:
            "Access a calendar of expert-led events on college counseling, NIL education, mentorship, and the application process.",
    },
];

export default function FamiliesPage() {
    return (
        <main className="solution-page">
            <PublicHeader />

            <section className="solution-hero">
                <h1 className="solution-hero-heading">For Families</h1>
                <p className="solution-hero-intro">{FAMILY_INTRO}</p>
                <Link to="/signup" className="solution-hero-btn">View Family Plan</Link>
            </section>

            <section className="solution-features-section">
                <div className="solution-features-card">
                    <div className="solution-features-top">
                        <div className="solution-features-intro-col">
                            <p className="solution-features-label">
                                <span className="solution-features-diamond" aria-hidden="true">✦</span> Our features
                            </p>
                            <h2 className="solution-features-heading">
                                Built For Families Supporting Student-Athletes.
                            </h2>
                            <p className="solution-features-intro">{FAMILY_CARD_INTRO}</p>
                        </div>
                        <figure className="solution-features-media">
                            <img
                                src={athleteImage}
                                alt="Polaris Athlete student-athlete"
                                className="solution-features-photo"
                            />
                            <figcaption className="solution-features-caption">
                                Polaris Athlete Mentor, Allaire Berl, Women&apos;s Tennis
                            </figcaption>
                        </figure>
                    </div>
                    <SolutionChecklist items={FAMILY_FEATURES} />
                </div>
            </section>

            <section className="landing-revprep">
                <div className="landing-revprep-inner">
                    <div className="landing-revprep-banner">
                        <img
                            src={revPrepBanner}
                            alt="Revolution Prep"
                            className="landing-revprep-banner-logo"
                        />
                        <div className="landing-revprep-banner-content">
                            <h3 className="landing-revprep-banner-heading">Free Test Prep &amp; Tutoring</h3>
                            <p className="landing-revprep-banner-desc">
                                All student-athletes receive 2 hours ($200+ value) of complimentary test prep
                                or tutoring through our partner, RevPrep, helping them strengthen academic
                                skills and stay on track for college success.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <IntegrationsBar />

            <PublicFooter />
        </main>
    );
}
